import { useCallback, useEffect, useState } from 'react';
import { API_BASE_URL } from '../components/config/api';

/**
 * Φαίνεται η επιλογή «Δελτίο Αποστολής» στο μενού του ταμία; Ναι μόνο με ανοιχτό τον διακόπτη του καταστήματος
 * (Ρυθμίσεις → Take Away) και ECR — το απαντά ο server (GET .../fiscal/delivery-note/availability).
 *
 * Κοινή μνήμη σε επίπεδο module, όπως το useManualInfo: το Navigation ξαναστήνεται σε κάθε αλλαγή σελίδας. Το άνοιγμα
 * του μενού ξαναρωτά όταν περάσει το λεπτό, ώστε ο διακόπτης να φαίνεται χωρίς F5.
 */
const TTL_MS = 60 * 1000;
let cache: { storeId: number; at: number; available: boolean } | null = null;

export function useDeliveryNoteAvailable(storeId: number | undefined) {
  const [available, setAvailable] = useState(() => !!storeId && cache?.storeId === storeId && cache.available);

  const refresh = useCallback(async () => {
    if (!storeId) { setAvailable(false); return; }
    if (cache && cache.storeId === storeId && Date.now() - cache.at < TTL_MS) {
      setAvailable(cache.available);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/api/stores/${storeId}/fiscal/delivery-note/availability`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('xentrix_token')}` },
      });
      if (!response.ok) return;
      const data = await response.json();
      cache = { storeId, at: Date.now(), available: data?.available === true };
      setAvailable(cache.available);
    } catch {
      /* χωρίς απάντηση μένει ό,τι ξέραμε */
    }
  }, [storeId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { available, refresh };
}

/** Για τα tests: καθαρή μνήμη ανάμεσα στις περιπτώσεις. */
export function resetDeliveryNoteAvailableCache() {
  cache = null;
}
